{
  "nome": "Smart Builder",
  "slug": "fabrica",
  "endereco": "builder.beadev.ai",
  "endereco_login": "login.beadev.ai",
  "porta_vps_dividida": 8444,
  "rede": "10.88.1.0/24"
}
